import { useLocation } from 'react-router-dom';

export const useIsOrganizationRoute = () => {
  const location = useLocation();
  const isOrganizationRoute = location.pathname.includes('/organizations/');

  return isOrganizationRoute;
};
